import React from "react";
import { Route, Routes } from "react-router-dom";
import Homepage from "../Pages/HomePage";
import ContactUs from "../Pages/ContactUs";
import IELTS from "../Pages/IELTS";
import PageNotFound from "../Pages/PageNotFound";
import PTE from "../Pages/PTE";
import MockTest from "../Pages/MockTest";
import AboutUs from "../Pages/AboutUs";
import UK from "../Pages/Countries/UK";
import Australia from "../Pages/Countries/Australia";
import Japan from "../Pages/Countries/Japan";
import Canada from "../Pages/Countries/Canada";
import USA from "../Pages/Countries/USA";

const Routing = () => {
  return (
    <>
      <Routes>
        <Route path="/" exact element={<Homepage />} />
        <Route path="/ielts" exact element={<IELTS />} />
        <Route path="/pte" exact element={<PTE />} />
        <Route path="/mock-test" exact element={<MockTest />} />
        <Route path="/contact-us" exact element={<ContactUs />} />
        <Route path="/about" exact element={<AboutUs />} />
        <Route path="/study-in-uk" exact element={<UK />} />
        <Route path="/study-in-australia" exact element={<Australia />} />
        <Route path="/study-in-japan" exact element={<Japan />} />
        <Route path="/study-in-canada" exact element={<Canada />} />
        <Route path="/study-in-usa" exact element={<USA />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export default Routing;
